// Define action types
export const CHOOSE_WEBSITE = 'CHOOSE_WEBSITE';